var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$attrs.center)?_c('MglMap',_vm._b({staticClass:"mgl-map",attrs:{"mapbox-gl":_vm.mapbox},on:{"load":_vm.onLoad}},'MglMap',{ ..._vm.$attrs, ..._vm.defaults },false),[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }